import {
  CardDTO,
  CardDTOCardReasonEnum,
  TransactionDTO,
  User,
} from "../generated/api";

export function isPrivileged(privileges: any, name: any, action: any): boolean {
  var result = false;

  if (name == null) {
    return true;
  }

  privileges?.forEach((privilege: any) => {
    if (privilege.name === name && privilege.action === action) {
      result = true;
    }
  });

  return result;
}

export function isTransactionEditable(
  transaction: TransactionDTO,
  user: User,
  carePrincipalId: string
) {
  if (transaction.status === "ACTIVE") {
    if (isPrivileged(user.privileges, "EFK.TRANSACTION.MODIFY", "WRITE")) {
      return transaction.carePrincipal?.id === carePrincipalId;
    } else if (
      isPrivileged(user.privileges, "EFK.TRANSACTION.MODIFYOWN", "WRITE")
    ) {
      return (
        user.healthCareProviderHsaId ===
          transaction.registeringCareProviderId &&
        transaction.carePrincipal?.id === carePrincipalId
      );
    }
  }
  return false;
}

export function isCardEditable(
  card: CardDTO,
  user: User,
  carePrincipalId: string
) {
  if (card?.status === "PRELIMINARY" || card?.status === "FINAL" || card?.status === "EXPIRED") {
    if (isPrivileged(user.privileges, "EFK.CARD.MODIFY", "WRITE")) {
      return card?.carePrincipal?.id === carePrincipalId;
    } else if (
      isPrivileged(user.privileges, "EFK.TRANSACTION.MODIFYOWN", "WRITE")
    ) {
      return (
        card?.cardReason === CardDTOCardReasonEnum.Validcard &&
        user?.healthCareProviderHsaId === card?.registeringCareProviderId &&
        card?.carePrincipal?.id === carePrincipalId
      );
    }
    return false;
  }
}
export function isCardDeletable(
  card: CardDTO,
  user: User,
  carePrincipalId: string
) {
  if (isPrivileged(user.privileges, "EFK.CARD.DELETE", "WRITE")) {
    return card.carePrincipal?.id === carePrincipalId;
  } else if (
    isPrivileged(user.privileges, "EFK.TRANSACTION.DELETEOWN", "WRITE")
  ) {
    if (card?.status !== "FINAL") {
      return (
        user?.healthCareProviderHsaId === card?.registeringCareProviderId &&
        card?.carePrincipal?.id === carePrincipalId &&
        card?.currentAmount === 0 &&
        card?.cardReason === CardDTOCardReasonEnum.Validcard
      );
    }
  }

  return false;
}
